module.exports = __webpack_public_path__ + "img/development (1).f2e97cb0.png";